/**
 * Created by jv on 16/03/2017.
 */
const utils = require("Sources/utils/utils");

const knownErrors = [
  "401", // unauthorized

  "E91489",
  "E73550",
];

module.exports = class AppError
{
  constructor(options)
  {
    options = utils.isNotNull(options) ? options : {};

    this.code = options.appErrorCode || options.code;
    this.message = options.message;

    this.data = options.data;
    this.exception = options.exception;
  }

  get readableErrorTitle()
  {
    if($.inArray(this.code, knownErrors) !== -1)
    {
      return "errors.services." + this.code + ".title";
    }

    return "errors.services.general.title";
  }

  get readableErrorMessage()
  {
    if($.inArray(this.code, knownErrors) !== -1)
    {
      //return "errors.services." + this.code + ".message";
      return this.code;
    }

    return "errors.services.general.message";
  }
};



// WEBPACK FOOTER //
// ./app/js/models/app-error.js